import { useState } from 'react';
import LoadingSpinner from '../components/layout/LoadingSpinner';
import { useDispatch, useSelector } from 'react-redux';
import { useGetAssignmentsAndReportsQuery } from '../api/assignments-and-reports';
import { RootState } from '../store';
import ReportsComingSoon from './ReportsComingSoon';
import { setTeacherPendingActionsWidgetOpen } from '../features/techerPendingActionsWidgetModal/teacherPendingActionsWidgetModalSlice';
import Reports from '../components/Reports/Reports';

const AssignmentsReports = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const product = useSelector((state: RootState) => state.product);
    const {
        data: assignments_and_reports_res,
        isError: assignments_and_reports_error,
    } = useGetAssignmentsAndReportsQuery({ product_type: product });
    const handleLoad = () => {
        setIsLoading(false);
    };

    return (
        <>
            <div
                className="w-full h-full"
                onClick={() => {
                    dispatch(setTeacherPendingActionsWidgetOpen(false));
                    return;
                }}
            >
                {product === 'ActiveTeach' && <Reports />}
                {isLoading && product === 'Buildr' && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                        <LoadingSpinner />
                    </div>
                )}
                {product === 'Buildr' && (
                    <iframe
                        className="content-iframe w-full h-full transition-opacity duration-500 ease-in-out"
                        src={assignments_and_reports_res?.data.url}
                        onLoad={handleLoad}
                        style={{ opacity: isLoading ? 0 : 1 }}
                    ></iframe>
                )}
            </div>
        </>
    );
};

export default AssignmentsReports;
